module.exports = __webpack_public_path__ + "img/female avatar-icon.b1dd10b1.svg";